import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialDivider from "../../../../__snowpack__/pkg/@mui/material/Divider.js";
import MaterialGrid from "../../../../__snowpack__/pkg/@mui/material/Grid.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React, {useCallback, useMemo} from "react";
import Button from "../../atoms/button/button.component.js";
import DataLabel from "../../atoms/data-label/data-label.component.js";
import {UnitsMergedContainer} from "./merge-suggestion-item.styles.js";
import {makeStyles} from "../../../../__snowpack__/pkg/@mui/styles.js";
const useStyles = makeStyles({
  word_break: {
    wordBreak: "break-all"
  }
});
function MergeSuggestionItem({
  pair,
  onQueue
}) {
  const {
    t
  } = useTranslation();
  const classes = useStyles();
  const unitSrc = useMemo(() => pair[0], [pair]);
  const unitDest = useMemo(() => pair[1], [pair]);
  const handleQueue = useCallback(() => {
    if (onQueue && pair?.length) {
      onQueue(pair);
    }
  }, [onQueue, pair]);
  return /* @__PURE__ */ React.createElement(UnitsMergedContainer, {
    elevation: 0
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    container: true,
    spacing: 2,
    direction: "row",
    alignItems: "center"
  }, /* @__PURE__ */ React.createElement(MaterialGrid, {
    className: classes.word_break,
    item: true,
    xs: 4
  }, /* @__PURE__ */ React.createElement(MaterialTypography, null, unitSrc.number), /* @__PURE__ */ React.createElement(DataLabel, {
    label: t("units.area"),
    content: unitSrc.sq_feet
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 1,
    alignSelf: "stretch"
  }, /* @__PURE__ */ React.createElement(MaterialDivider, {
    orientation: "vertical"
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    className: classes.word_break,
    item: true,
    xs: 4
  }, /* @__PURE__ */ React.createElement(MaterialTypography, null, unitDest.number), /* @__PURE__ */ React.createElement(DataLabel, {
    label: t("units.area"),
    content: unitDest.sq_feet
  })), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true,
    xs: 3
  }, /* @__PURE__ */ React.createElement(Button, {
    onClick: handleQueue,
    variant: "outlined",
    size: "small",
    color: "secondary"
  }, t("units.queue")))));
}
export default /* @__PURE__ */ React.memo(MergeSuggestionItem);
